export const SCHOOL_TYPES = ['po', 'vo', 'sbo', 'so', 'vso'] as const;
export type SchoolType = typeof SCHOOL_TYPES[number];

export function isSchoolType(
    possibleSchoolType: string | undefined,
): possibleSchoolType is SchoolType {
    return (SCHOOL_TYPES as readonly string[]).includes(String(possibleSchoolType));
}
